var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 34.442,
    height: 34.442,
    viewBox: "0 0 32.442 32.442",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-YouTube_Logo_32_x_32px_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32.442,
    height: 32.442
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "YouTube_Logo_32_x_32px_1",
    "data-name": "YouTube Logo \\u201332 x 32px \\u2013 1",
    clipPath: "url(#clip-YouTube_Logo_32_x_32px_1)",
    opacity: 0.497
  }, /*#__PURE__*/React.createElement("g", {
    id: "youtube",
    transform: "translate(-13.207 -13.166)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M29.207,14.166a15.223,15.223,0,1,0,15,15.221A15.112,15.112,0,0,0,29.207,14.166Zm8.4,18.651a2.1,2.1,0,0,1-2.088,2.119A51.272,51.272,0,0,1,29.1,35.2a47.209,47.209,0,0,1-6.295-.263,2.1,2.1,0,0,1-2.088-2.119V25.826a2.1,2.1,0,0,1,2.088-2.119,47.158,47.158,0,0,1,6.29-.263,51.326,51.326,0,0,1,6.419.263,2.1,2.1,0,0,1,2.088,2.118Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M62.019,65.927l5.872-3.39-5.872-3.39Z",
    transform: "translate(-35.502 -33.196)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.9e30ae6b4e60934ad3a08510d1ec9643.svg";
export { ForwardRef as ReactComponent };